"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _dateFns = require("date-fns");

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

var _excluded = ["__typename"],
    _excluded2 = ["__typename"],
    _excluded3 = ["__typename"],
    _excluded4 = ["_id", "__typename"],
    _excluded5 = ["_id", "author", "createdAt", "__typename"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 1024
    },
    dialog: {
      minWidth: 340
    }
  };
});

var EditList = function EditList(_ref) {
  var edits = _ref.edits,
      openFabricate = _ref.openFabricate,
      setPdfOpen = _ref.setPdfOpen,
      labels = _ref.labels;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      detailOpen = _useState2[0],
      setDetailOpen = _useState2[1];

  var classes = useStyles();

  if (!edits || edits.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
      Icon: _Edit["default"],
      label: labels.empty
    });
  }

  var renderChange = function renderChange(_ref2) {
    var __typename = _ref2.__typename,
        other = _objectWithoutProperties(_ref2, _excluded);

    if (__typename === 'TechnicalSheetVersion') {
      var technicalSheet = other.technicalSheet,
          restricted = other.restricted;
      return restricted ? "".concat(labels.TechnicalSheetVersionRestricted, ": ").concat(technicalSheet.version) : "".concat(labels.TechnicalSheetVersion, ": ").concat(technicalSheet.version);
    }

    return labels[__typename];
  };

  var renderChildren = function renderChildren(_ref3) {
    var __typename = _ref3.__typename,
        other = _objectWithoutProperties(_ref3, _excluded2);

    // if (__typename === 'TechnicalSheetVersion') {
    //   const { technicalSheet } = other;
    //   return <Typography>{technicalSheet.notes}</Typography>;
    // }
    return null;
  };

  var renderExtraLabel = function renderExtraLabel(_ref4) {
    var __typename = _ref4.__typename,
        other = _objectWithoutProperties(_ref4, _excluded3);

    if (__typename === 'TechnicalSheetVersion') {
      var technicalSheet = other.technicalSheet;
      return " - ".concat(technicalSheet.fileName);
    }

    return '';
  };

  var renderChangeDetails = function renderChangeDetails(editId) {
    var edit = edits.find(function (_ref5) {
      var _id = _ref5._id;
      return _id === editId;
    });

    if (edit) {
      var __typename = edit.__typename;

      if (__typename === 'FabricateEdit') {
        return ['description', 'code', 'name', 'specification'].filter(function (key) {
          return !!edit[key];
        }).map(function (key) {
          return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
            text: labels.fabricate[key],
            textLabel: edit[key]
          });
        });
      }

      if (__typename === 'CertificateEdit') {
        return ['description'].filter(function (key) {
          return !!edit[key];
        }).map(function (key) {
          return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
            text: labels.certificate.description,
            textLabel: edit[key]
          });
        });
      }

      if (__typename === 'TechnicalSheetVersion') {
        return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
          text: edit.technicalSheet.version,
          textLabel: edit.technicalSheet.notes
        });
      }
    }

    return 'no edits';
  };

  var _onClick = function onClick(_ref6) {
    var _id = _ref6._id,
        __typename = _ref6.__typename,
        other = _objectWithoutProperties(_ref6, _excluded4);

    if (__typename === 'FabricateAdd') {
      return openFabricate(_id);
    }

    if (__typename === 'TechnicalSheetVersion') {
      var technicalSheet = other.technicalSheet;
      return setPdfOpen(technicalSheet.src);
    }

    setDetailOpen(_id);
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.List, {
    classes: {
      root: classes.root
    }
  }, edits.map(function (_ref7) {
    var _id = _ref7._id,
        author = _ref7.author,
        createdAt = _ref7.createdAt,
        __typename = _ref7.__typename,
        other = _objectWithoutProperties(_ref7, _excluded5);

    return author && (__typename === 'TechnicalSheetVersion' ? /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: author.person.avatar && author.person.avatar.src
      }),
      interactive: true,
      description: "".concat(labels.description({
        date: (0, _dateFns.format)(new Date(createdAt), 'yyyy.MM.dd'),
        author: author.person.fullName
      })).concat(renderExtraLabel(_objectSpread({
        __typename: __typename
      }, other))),
      label: renderChange(_objectSpread({
        __typename: __typename
      }, other)),
      fileUrl: other.technicalSheet.src,
      onClickOpen: function onClickOpen() {
        return setPdfOpen(other.technicalSheet.src);
      },
      onClickDownloadFile: function onClickDownloadFile() {
        return window.open(other.technicalSheet.src, '__blank');
      }
    }) : /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: author.person.avatar && author.person.avatar.src
      }),
      textLabel: "".concat(labels.description({
        date: (0, _dateFns.format)(new Date(createdAt), 'yyyy.MM.dd'),
        author: author.person.fullName
      })).concat(renderExtraLabel(_objectSpread({
        __typename: __typename
      }, other))),
      text: renderChange(_objectSpread({
        __typename: __typename
      }, other)),
      onClick: function onClick() {
        return _onClick(_objectSpread({
          _id: _id,
          __typename: __typename
        }, other));
      }
    }, renderChildren(_objectSpread({
      __typename: __typename
    }, other))));
  })), /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: !!detailOpen,
    classes: {
      paper: classes.dialog
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, labels.title), detailOpen ? /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_core.List, null, renderChangeDetails(detailOpen))) : '', /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return setDetailOpen(null);
    }
  }, "Ok"))));
};

EditList.propTypes = {
  className: _propTypes["default"].string,
  edits: _propTypes["default"].array
};
EditList.defaultProps = {
  className: '',
  edits: []
};
var _default = EditList;
exports["default"] = _default;